import React from 'react';
import moment from 'moment/moment';

import Icon from '../../../../../../../common/general/Icon';

export const SignatureOverlayForEncounter = ({ signedUsers, reviews }) => {
  return reviews?.map((review, key) => {
    const performedSignature = signedUsers.find(
      signature => signature.groupId === review.groupId && signature.unsignedCount === 0
    );
    return performedSignature ? (
      <div className="d-flex align-items-center i my-2" style={{ height: '18px' }} key={key}>
        <Icon style={{ fontSize: '25px', marginRight: '15px', fontWeight: 'bold' }}>done</Icon>
        {review.groupName + ', ' + getSignatureInfo(performedSignature)}
      </div>
    ) : (
      <div className="my-2" style={{ marginLeft: signedUsers?.length ? '2.5rem' : '0.5rem' }} key={key}>
        {review.groupName}
      </div>
    );
  });
};

const getSignatureInfo = signature => {
  return signature.signerName + ', ' + moment(signature.signatureDateTime).format('DD/MMM/YYYY, h:mm a');
};
